import { useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { propertyUtils } from '@zg-rentals/rental-manager-env';

import { useSelector } from '../../../../selectors/useSelector';

import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

import RoomSquareFootageFormField from './RoomSquareFootageFormField';
import SquareFootageFormField from './SquareFootageFormField';
import BedroomsFormField from './BedroomsFormField';
import BathroomsFormField from './BathroomsFormField';
import MapPinAdjustmentAlert from '../../../MapPinAdjustmentAlert';

const FormSectionContainer = () => {
  const { currentProperty } = useSelector(
    (state) => ({
      currentProperty: state.properties.currentProperty,
    }),
    shallowEqual,
  );

  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });

  const heading = useMemo(() => {
    if (isRoomForRent) {
      return 'Confirm some facts about the room and property';
    }

    return `Let’s start creating your listing`;
  }, [isRoomForRent]);

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      {!isRoomForRent && <MapPinAdjustmentAlert />}
      <WizardHeading textStyle="heading-sm" level={1}>
        {heading}
      </WizardHeading>

      {!isRoomForRent && <WizardBody>Add or review details about your property&apos;s size.</WizardBody>}

      {isRoomForRent && <RoomSquareFootageFormField />}
      <SquareFootageFormField />
      <BedroomsFormField />
      <BathroomsFormField />
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
